module.exports = __webpack_public_path__ + "static/media/DigiNanny and Schools.c2de89a8.png";